<template>
  <div class="pure-button-group" role="group">
    <button class="pure-button radio radio-left" @click.prevent="updateValue(true)"
            :class="{ active: value }">Yes
    </button>
    <button class="pure-button radio radio-right" @click.prevent="updateValue(false)"
            :class="{ active: !value }">No
    </button>
  </div>
</template>

<script>
  export default {
    name: 'YesNo',
    props: ['value'],
    methods: {
      updateValue(value) {
        this.$emit('input', value);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// YesNo.vue?06684b92